import BaseService from './BaseService';
import { ThoughtSpotTokenResponse } from '../apis/AnalyticsServiceAPI';

export default class AnalyticsService extends BaseService {
  /**
   * Fetches a ThoughtSpot embed token for the current user.
   * The token is scoped to the given organization and grants full liveboard access.
   */
  async getThoughtSpotToken(
    organizationId: string,
    groupName: string
  ): Promise<ThoughtSpotTokenResponse> {
    const { currentUser } = this.host as Record<string, any>;

    // ThoughtSpot requires a valid email as the username for user identity and auto-provisioning.
    // The user's primary email lives in the emails array, not a top-level field.
    const email = currentUser.emails?.[0]?.address || currentUser.username || currentUser.id;
    return this.host.api.analyticsService.getThoughtSpotToken(organizationId, {
      accountToken: currentUser.id,
      orgId: organizationId,
      username: email,
      displayName: currentUser.displayName || currentUser.username || currentUser.id,
      tokenType: 'FULL',
      groupName: groupName,
      autoCreate: true,
      validityTimeInSec: 24 * 60 * 60,
    });
  }
}
